export class BulkSelectSnapshotsForResourcesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkSelectSnapshotsForResourcesResponseItemsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkSelectSnapshotsForResourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
